import { ModelSagres } from "@/types/model-sagres";

export class EmendaResumida extends ModelSagres {
    IdEmenda: number
    NrEmenda: string
    NrAnoEmenda: number
    DtEmenda: Date
    TipoEmenda: string
    NmAutor: string
    VlEmenda: number
    FlAtivo: boolean

    constructor(obj?: any) {
        super();
        if (obj) {
            if (obj.IdEmenda) this.IdEmenda = obj.IdEmenda
            if (obj.NrEmenda) this.NrEmenda = obj.NrEmenda
            if (obj.NrAnoEmenda) this.NrAnoEmenda = obj.NrAnoEmenda
            if (obj.DtEmenda) this.DtEmenda = obj.DtEmenda
            if (obj.TipoEmenda) this.TipoEmenda = obj.TipoEmenda
            if (obj.NmAutor) this.NmAutor = obj.NmAutor
            if (obj.VlEmenda) this.VlEmenda = obj.VlEmenda
            if (obj.FlAtivo !== undefined) this.FlAtivo = obj.FlAtivo
        }
    }
}